import { CLIENT_LOGO_FILES } from '../data/clientLogoFiles';

/** Build logo URL candidates — local files in /public/clients/logos/ are tried first. */
export function getClientLogoSources(client) {
  const sources = [];
  if (client.logo) {
    sources.push(`/clients/logos/${client.logo}`);
  }
  const mapped = client.slug && CLIENT_LOGO_FILES[client.slug];
  if (mapped) {
    sources.push(`/clients/logos/${mapped}`);
  }
  if (client.slug) {
    for (const ext of ['png', 'jpg', 'webp', 'svg']) {
      const candidate = `/clients/logos/${client.slug}.${ext}`;
      if (!sources.includes(candidate)) sources.push(candidate);
    }
  }
  if (client.domain) {
    sources.push(`https://logo.clearbit.com/${client.domain}`);
  }
  return sources;
}

export function getClientInitials(name) {
  const stop = new Set(['ltd', 'limited', 'pvt', 'inc', 'india', 'the', 'and', 'of', 'co']);
  const words = name
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean);
  const significant = words.filter((w) => !stop.has(w.toLowerCase()));
  const pick = (significant.length ? significant : words).slice(0, 2);
  return pick.map((w) => w[0]).join('').toUpperCase() || '?';
}

export function clientSlug(name) {
  return name
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
